import React from "react";

const DateField = ({ index, field, handleChange, readOnlyForm }) => {

    /**
     * Render the date input
     */
    return (
        <div className="p-2">
            <label htmlFor={field.id} className={`form-label fw-bolder m-2 ${field.required ? "required" : ""}`}>{field.label}</label>
            <input
                className="form-control"
                type="date"
                id={field.id}
                name={field.id}
                defaultValue={field.value}
                onChange={e => handleChange(index, e)}
                readOnly={readOnlyForm}
            />
        </div>
    );
};

export default DateField;